import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHeart, FiHome, FiTshirt, FiUsers } = FiIcons;

const WhatToExpect = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-serif mb-8" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>
            Was dich erwartet
          </h2>
          <p className="text-lg max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
            Alles ist für dich vorbereitet.<br />
            Wir gestalten den Raum ruhig, warm und einladend – ein Ort, an dem du zur Ruhe finden kannst.
          </p>
        </motion.div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-lg leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
              Du brauchst nur bequeme Kleidung und etwas Zeit für dich.<br />
              Matten, Decken und Bolster stellen wir bereit.<br />
              Die Stunden sind für Anfänger*innen und Fortgeschrittene geeignet – du brauchst keine Vorerfahrung.
            </p>
            
            <p className="text-lg leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
              Marcella bringt ihre Klangschalen mit und begleitet die Stunde mit sanften Klängen.<br />
              Die Schalen dienen der Entspannung – du hörst und spürst sie, ohne selbst etwas tun zu müssen.
            </p>
            
            <p className="text-lg leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
              Wenn du eigene Lieblingssachen hast – eine Lieblingsdecke, ein Meditationstuch oder ein Kissen – kannst du sie gerne mitbringen. Es geht darum, dass du dich wohlfühlst.
            </p>

            <p className="text-lg leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
              Von dem Moment an, in dem du den Raum betrittst, darfst du einfach ankommen.
            </p>
          </motion.div>
          
          {/* Features Grid */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 sm:grid-cols-2 gap-6"
          >
            {[
              {
                icon: FiHome,
                title: "Wohlfühlatmosphäre",
                description: "Einladender Raum für tiefe Entspannung"
              },
              {
                icon: FiTshirt,
                title: "Bequem dabei",
                description: "Nur bequeme Kleidung benötigt"
              },
              {
                icon: FiHeart,
                title: "Herzlich willkommen",
                description: "Für Anfänger*innen und Fortgeschrittene"
              },
              {
                icon: FiUsers,
                title: "Kleine Gruppe",
                description: "Maximal 4 Teilnehmende für persönliche Betreuung"
              }
            ].map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05, y: -5 }}
                className="bg-gradient-to-br from-stone-50 to-amber-50 p-6 rounded-2xl shadow-lg border text-center"
                style={{ borderColor: '#E8E2DC' }}
              >
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md" style={{ backgroundColor: '#CBB8A9' }}>
                  <SafeIcon icon={feature.icon} className="w-8 h-8" style={{ color: '#314C40' }} />
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>
                  {feature.title}
                </h3>
                <p className="leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatToExpect;